import React from 'react'
import style from "./AdminFooter.module.css"

export const AdminFooter = () => {
  return (
    <footer className={style.footer}>
    <div className={style['footer-content']}>
      <span className={style['footer-text']}>© 2024 | Loyal String International Pvt. Ltd.</span>
      <span className={style['footer-text']}>All Rights Reserved</span>
    </div>
  </footer>
  )
}
